<template>
	<div class="rows">
		<div :class="options.wrapperClass">
			<button
				type="button"
				:disabled="watchDisabled"
				@click="handleClick"
				:class="['button w-100 mb-30px', options.className]"
			>
				{{ options.text }}
			</button>
		</div>
	</div>
</template>

<script>
import shared from '@/mixins/shared';
import { mapGetters, mapMutations } from 'vuex';

export default {
	data() {
		return {
			watchDisabled: false,
		};
	},
	computed: {
		...mapGetters(['getOutbuildings']),
	},
	mixins: [shared],
	methods: {
		...mapMutations(['showPopup', 'newOutbuilding', 'newBuilding', 'popupHasClose']),
		handleClick() {
			if (this.name === 'place') {
                this.popupHasClose(false);
				this.showPopup('FloorAreaLists');
			}

			if (this.name === 'outbuilding') {
				this.newOutbuilding();
			}

			if (this.name === 'property_movables') {
				this.showPopup('PropertyMovables');
			}

			if (this.name === 'property_valuables') {
				this.showPopup('PropertyValuables');
			}

			if (this.name === 'buildings') {
				this.newBuilding();
			}
		},
	},
	watch: {
		getOutbuildings(newVal, oldVal) {
			if (this.name === 'outbuilding') {
				this.watchDisabled = newVal.length >= 5;
			}
		},
	},
};
</script>
